import React from "react";
import { withRouter } from "react-router-dom";

import { Button } from "aible";

import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import CostsBlueprint from "components/Costs/CostsBlueprint";

export default class CurrentState extends React.PureComponent {
  render() {
    const { costs, processLimit, isHeader, isSmall, initRun, step, tile, updateStep, blueprint, forceShow } =
      this.props;

    return (
      <div
        className={styles.currentState}
        style={isHeader ? { height: "150px", margin: "10px" } : isSmall ? { height: "230px" } : { height: "45vh" }}
      >
        {/*
        <div className={styles.tileHolder}>
          <div className={styles.tile}>{tile}</div>
        </div>
        */}
        <div
          className={styles.cHolder}
          style={
            step === "current"
              ? {
                  borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                  borderRadius: "3px"
                }
              : {}
          }
        >
          <div className={styles.editor}>
            {costs}
            {processLimit}
          </div>
          {blueprint && (
            <div className={styles.blueprint}>
              <CostsBlueprint blueprint={blueprint} />
            </div>
          )}
        </div>
        {step === "current" && (
          <div className={styles.buttonHolder}>
            <Button type="primary" onClick={() => updateStep("models")}>
              {"Select Models"}
            </Button>
          </div>
        )}
      </div>
    );
  }
}
